import {
  Box,
  Dialog as MuiDialog,
  IconButton,
  styled,
  Typography,
  useMediaQuery
} from '@mui/material'
import format from 'date-fns/format'
import getDay from 'date-fns/getDay'
import parse from 'date-fns/parse'
import startOfWeek from 'date-fns/startOfWeek'
import {
  FC,
  SetStateAction,
  useCallback,
  useMemo,
  useState,
  useEffect
} from 'react'
import { Calendar, dateFnsLocalizer, Views } from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import 'react-datepicker/dist/react-datepicker.css'
import { flexItemCenter } from '../../global'
import { ToolbarComponent } from '../CalendarToolbarComponent/ToolbarComponent'
import { allEvents } from '../../services/EventService'
import { useNavigate } from 'react-router-dom'
import { appTheme } from '../../theme'
import { Role, EventStatus } from '../../services/Types'
import moment from 'moment'
import { useStyles } from './style'
import { ToolTip } from './TootTip'
import { wrap } from 'module'
import { EventDetailsPopup } from './EventDetailsPopup'
import { getStatusColors } from '../../helpers/statusColors'

export interface CalendarEventDataInterface {
  title: string
  summary: string
  id: number
  createrId: number
  eventType: string
  start: Date
  end: Date
  startString: string
  endString: string
  startTime: string
  endTime: string
  category: string
  status: string
}

export interface ETACalendarProps {
  selectedStatus: string[]
  currentDefaultView: any
  userData: string
}
var isMobView = false

const Dialog = styled(MuiDialog)`
  backdrop-filter: blur(12px);
  background: rgba(249, 251, 252, 0.7);
  padding-bottom: 200px;
  top: 64px;

  .MuiDialog-paper {
    border: 1px solid rgba(0, 0, 0, 0.02);
    border-radius: 12px;
    box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.2);
    overflow-y: inherit;
  }
`

const locales = {
  'en-US': require('date-fns/locale/en-US')
}

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales
})

const eventProps = (event: any) => {
  let newStyle = {
    color: 'white',
    backgroundColor: '',
    height: '19.02px',
    lineHeight: '14px',
    gap: '18px',
    alignItems: 'center',
    justifyContent: 'center'
  }

  const statusColors = getStatusColors(event.status);
  newStyle.backgroundColor = statusColors.backgroundColor;
  newStyle.color = statusColors.color;

  let user: any = localStorage.getItem('user')
  if (user !== 'null' && user !== null && user !== undefined) {
    user = JSON.parse(user)
    if (user.role === Role.REQUESTER) {
      if (
        event.status === 'APPROVAL1' ||
        event.status === 'APPROVAL2' ||
        event.status === 'APPROVAL3'
      ) {
        newStyle.backgroundColor = 'rgba(255, 87, 34, 1)'
        newStyle.color = 'white'
      }
    }
    if (user.role === Role.APPROVER || user.role === Role.ADMIN) {
    }
  }

  if (event.category === 'dry' && event.status !== 'BLOCKED') {
    newStyle.backgroundColor = 'rgba(98, 0, 234, 1)'
    newStyle.color = 'white'
  }

  return {
    className: '',
    style: newStyle
  }
}

const convertMinutesIntoTime = (time: number): string => {
  if (time === 0) {
    return '00:00 AM ET'
  }
  let period = 'AM ET'
  let hours = Math.floor(time / 60)
  let minutes: any = Math.floor(time % 60)
  if (minutes === 0) {
    minutes = '00'
  }
  if (hours > 11) {
    period = 'PM ET'
  }
  if (hours > 12) {
    hours = hours - 12
  }
  let timeSlot = `${hours}:${minutes} ${period}`
  return timeSlot
}

var currentView = 'month'

export const EtaCalendar: FC<ETACalendarProps> = ({
  selectedStatus,
  currentDefaultView = Views.MONTH,
  userData
}) => {
  isMobView = useMediaQuery(appTheme.breakpoints.down('md'))
  const classes = useStyles()
  const [view, setView] = useState('month')
  const user: any = localStorage.getItem('user')
  var onView = useCallback(
    (newView: SetStateAction<string>) => setView(newView),
    [setView]
  )

  const WeekDay = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT']
  const { formats } = useMemo(
    () => ({
      formats: {
        weekdayFormat: (date: Date) => WeekDay[date.getDay()],
        dateFormat: (date: Date) => localizer.format(date, 'd', 'en')
      }
    }),
    []
  )

  const [events, setEvents] = useState<any>([])
  const [openEventDetails, setOpenEventDetails] = useState<any>(null)

  const getAllEvents = async () => {
    try {
      const { data } = await allEvents()
      if (data) {
        if (data.events.statusCode === 200) {
          const allBookingData: any[] = []

          data.events.data.forEach((value: any) => {
            if (
              value.status === EventStatus.BLOCKED &&
              value.roomBooking.length > 0 &&
              view === 'month'
            ) {
              const startBooking = value.roomBooking[0]
              let startDate = moment.utc(Number(startBooking.date))

              const endBooking = value.roomBooking.at(-1)
              let endDate = moment.utc(Number(endBooking.date))

              let currentDate = moment.utc(Number(startBooking.date))
              while (currentDate.isSameOrBefore(endDate)) {
                let event = {
                  id: value.id,
                  createrId: value.createrId,
                  title: value.title,
                  summary: value.summary,
                  start: new Date(startDate.format().slice(0, -1)),
                  end: new Date(
                    currentDate.clone().add(1, 'second').format().slice(0, -1)
                  ),
                  startTime: convertMinutesIntoTime(startBooking.startTime),
                  endTime: convertMinutesIntoTime(startBooking.endTime),
                  status: EventStatus.BLOCKED
                }

                if (currentDate.day() === 5 && currentDate.isBefore(endDate)) {
                  allBookingData.push(event)

                  currentDate.add(3, 'days')
                  startDate = currentDate.clone()
                } else if (currentDate.isSame(endDate)) {
                  allBookingData.push(event)

                  currentDate.add(1, 'day')
                } else {
                  currentDate.add(1, 'day')
                }
              }
            } else {
              value.roomBooking.forEach((booking: any) => {
                const eventDate = Number(booking.date)

                let eventBookingDate = moment.utc(eventDate)
                let startHours = Math.floor(booking.startTime / 60)
                let startMinutes = Math.floor(booking.startTime % 60)
                eventBookingDate.set({ hour: startHours, minute: startMinutes })

                let eventEndDate = moment.utc(eventDate)
                let endHours = Math.floor(booking.endTime / 60)
                let endMinutes = Math.floor(booking.endTime % 60)
                eventEndDate.set({ hour: endHours, minute: endMinutes })

                let eventStatus = value.status
                if (user !== 'null' && user !== null) {
                  eventStatus =
                    JSON.parse(userData).id !== value.createrId &&
                    JSON.parse(user).role !== 'ADMIN' &&
                    JSON.parse(user).role !== 'APPROVER'
                      ? 'BLOCKED'
                      : value.status
                }

                // to show all events as blocked for guest users
                if (user === 'null' || user === null) {
                  eventStatus = 'BLOCKED'
                }

                const startDate = new Date(eventBookingDate.format().slice(0, -1))
                const endDate = new Date(eventEndDate.format().slice(0, -1))
                const startDateString = moment(startDate).format('ddd MMM DD, YYYY')
                let endDateString = moment(endDate).format('ddd MMM DD, YYYY')

                if (startDateString === endDateString) {
                  endDateString = ''
                } else {
                  endDateString = ' - ' + endDateString
                }

                const event: CalendarEventDataInterface = {
                  id: value.id,
                  createrId: value.createrId,
                  title: value.title,
                  summary: value.summary,
                  eventType: value.eventType,
                  start: startDate,
                  end: endDate,
                  startString: startDateString,
                  endString: endDateString,
                  startTime: convertMinutesIntoTime(booking.startTime),
                  endTime: convertMinutesIntoTime(booking.endTime),
                  category: booking.category,
                  status: eventStatus
                  //status : JSON.parse(userData).id !== value.createrId && (JSON.parse(user).role !== "ADMIN" && JSON.parse(user).role !== "APPROVER") ? 'ETA' : value.status
                }
                allBookingData.push(event)
              })
            }
          })
          setEvents(allBookingData)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    // let allBookings:any[] = []

    const load = async () => {
      await getAllEvents()
    }
    load()
  }, [])

  useEffect(() => {
    currentView = view
    const load = async () => {
      await getAllEvents()
    }
    load()
  }, [view])

  const dayPropGetter = (date: Date) => ({
    ...(moment(date).day() === 0 && {
      style: {
        backgroundColor: 'rgba(37, 61, 130, 0.04)',
        disabled: true
      }
    }),
    ...(moment(date).day() === 6 && {
      style: {
        backgroundColor: 'rgba(37, 61, 130, 0.04)',
        disabled: true
      }
    })
  })

  return (
    <div>
      <Box style={flexItemCenter}>
        <Calendar
          tooltipAccessor={''}
          dayPropGetter={dayPropGetter}
          localizer={localizer}
          events={events.filter((e: any) => {
            return (
              (selectedStatus.indexOf(e.status) !== -1 &&
                e.category === 'live') ||
              (selectedStatus.includes('DRY') &&
                e.category === 'dry' &&
                e.status !== 'BLOCKED') ||
              (selectedStatus.indexOf(e.status) !== -1 &&
                e.status === 'BLOCKED')
            )
          })}
          formats={formats}
          defaultView={currentDefaultView}
          startAccessor='start'
          endAccessor='end'
          onView={onView}
          defaultDate={new Date()}
          components={{
            toolbar: ToolbarComponent,
            event: CustomEvent
          }}
          className={classes.style}
          eventPropGetter={event => eventProps(event)}
          timeslots={2}
          onSelectEvent={(event: any) => setOpenEventDetails(event)}
          max={new Date('1970-01-01T18:00:00.000Z'.slice(0, -1))}
          min={new Date('1970-01-01T09:00:00.000Z'.slice(0, -1))}
        />
      </Box>

      {/* {/ Event Details Dialog Box /} */}
      {openEventDetails && (
        <EventDetailsPopup
          id={openEventDetails.id}
          open={typeof openEventDetails != "undefined"}
          setOpen={setOpenEventDetails}
        />
      )}
    </div>
  )
}

const CustomEvent = (props: any) => {
  let status = props.event.status
  let startTime = props.event.startTime
  let endTime = props.event.endTime
  let title = props.event.title
  let allDay = props.event.allDay
  let summary = props.event.summary
  let eventType = props.event.eventType
  var eventText = currentView !== 'month' || isMobView ? '' : title

  const date = moment(props.event.start)
  let day = date.format('MM/DD/YYYY')

  if (allDay !== true && currentView === 'month' && isMobView === false) {
    eventText = `${startTime}`
    if (status === 'APPROVAL1') {
      eventText = `${eventText}`
    } else if (status === 'APPROVAL2') {
      eventText = `${eventText}`
    } else if (status === 'APPROVAL3') {
      eventText = `${eventText}`
    }
  }

  return (
    <Box>
      <ToolTip
        currentView={currentView}
        title={title}
        day={day}
        startTime={startTime}
        endTime={endTime}
      >
        {allDay === true ? (
          <Box className='rbc-event-block' data-testid={`event-${props.event.id}-${props.event.category}`}>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: '12px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: '1',
                WebkitBoxOrient: 'vertical'
              }}
            >
              {title}
            </Typography>
          </Box>
        ) : (
          <Box className='rbc-event-block' data-testid={`event-${props.event.id}-${props.event.category}`}>
            <Typography sx={{ fontWeight: 700, fontSize: '12px' }}>
              {eventText}
            </Typography>

            {currentView !== 'agenda' && (
              <Typography display='inline' noWrap>
                &nbsp;
              </Typography>
            )}

            <Typography
              sx={{
                fontWeight: 400,
                fontSize: '12px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: '1',
                WebkitBoxOrient: 'vertical',
                marginTop: currentView === 'agenda' ? '-2px' : '0px'
              }}
            >
              {title}
            </Typography>
          </Box>
        )}
      </ToolTip>
    </Box>
  )
}
